import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-379d8754"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-bet-all", "data-bet-u"]
const _hoisted_2 = ["data-ratio"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "good-road-bet-box",
    ref: "rootEl",
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.placeBet && _ctx.placeBet(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", {
      class: "bet-infos",
      "data-bet-all": `${_ctx.t('game.one')}:${_ctx.sumOfTempBetandConfirmedBet}`,
      "data-bet-u": `${_ctx.t('game.total')}: ${_ctx.totalBet ?? 0}`
    }, null, 8, _hoisted_1),
    _createElementVNode("div", {
      class: _normalizeClass(["bet-label", _ctx.color]),
      ref: "labelEl",
      "data-ratio": _ctx.betRatio
    }, _toDisplayString(_ctx.betlabel), 11, _hoisted_2),
    _createElementVNode("div", {
      class: "chips-list",
      style: _normalizeStyle(_ctx.chipContainerStyle)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chipsUI, (chip, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["chip", chip.class]),
          key: index,
          style: _normalizeStyle(`top:${_ctx.getChipPositionStyle(chip.y)};left:${_ctx.getChipPositionStyle(chip.x)};`)
        }, _toDisplayString(_ctx.toShortValue(chip.amount)), 7))
      }), 128))
    ], 4)
  ], 512))
}